import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const ThemeCtx = createContext({ mode: "light", setMode: () => {} });

function applyTheme(mode) {
  const effective = mode === "auto"
    ? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")
    : mode;
  const root = document.documentElement;
  root.dataset.theme = effective;
  root.dataset.themeChoice = mode;
  // Tailwind/Shadcn dark mode is class-based ("darkMode: class")
  if (effective === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  root.style.colorScheme = effective;
}

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => localStorage.getItem("ma_theme") || "light");

  useEffect(() => {
    applyTheme(mode);
    localStorage.setItem("ma_theme", mode);
    if (mode === "auto") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      const h = () => applyTheme("auto");
      mq.addEventListener("change", h);
      return () => mq.removeEventListener("change", h);
    }
  }, [mode]);

  // Sync from server on mount if logged
  useEffect(() => {
    if (!localStorage.getItem("ma_token")) return;
    api.get("/me/preferences").then(r => {
      const server = r.data?.ui_preferences?.theme;
      if (server && server !== mode) setModeState(server);
    }).catch(() => {});
  }, []); // eslint-disable-line

  const setMode = async (m) => {
    setModeState(m);
    try { await api.put("/me/preferences", { theme: m }); } catch {}
  };

  return <ThemeCtx.Provider value={{ mode, setMode }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
